module.exports = __webpack_public_path__ + "img/img_logo_text.070f968c.svg";